<template>
  <div class="notes-list">
    <MatterPageList :list="list" :seperator="false">
      <template v-slot:list-prview="{ item }">
        <div class="notes-list-preview" @click="handleNoteAction({action: 'edit', noteUid: item.uid, page: item.page})">
          <NoteCard
            :note="item"
            :staff-name="getStaffName(item.staffUid)"
            @action="handleNoteAction"
            :display-author="displayAuthor"
            :menu-on-hover="menuOnHover"/>
        </div>
      </template>
    </MatterPageList>
    <InfiniteScroll
      @on-scroll="loadMore"
      :is-empty="isEmpty"
      :identifier="refreshId"
      :no-result-txt="$t('client.matters.matter_page.notes_tab.no_items_found')" />
  </div>
</template>

<script>
import {InfiniteScroll} from "@/modules/common/components"
import MatterPageList from '@/modules/matters/components/matterPageList/MatterPageList'
import NoteCard from '@/modules/matters/components/NoteCard/NoteCard'

export default {
  name: "NotesList",
  components: {
    InfiniteScroll,
    MatterPageList,
    NoteCard,
  },
  props: {
    displayAuthor: {
      type: Boolean,
      default: true
    },
    menuOnHover: {
      type: Boolean,
      default: true
    },
    refreshId: {
      type: Number,
      required: true
    }
  },
  computed: {
    isMultipleStaffs() {
      return this.$store.getters['accountModule/isMultipleStaffs']
    },
    matter() {
      return this.$store.getters['mattersModule/matter']
    },
    list() {
      return this.$store.getters['mattersModule/notes']
    },
    currPage() {
      return this.$store.getters['mattersModule/notesPage']
    },
    isCompleted() {
      return this.$store.getters['mattersModule/notesCompleted']
    },
    isEmpty(){
      return this.isCompleted && this.list.length === 0
    },
    staffMembers() {
      return this.$store.getters['accountModule/staffMembers']
    }
  },
  methods: {
    async loadMore($state) {
      const page = this.currPage
      this.$store.commit('mattersModule/setNotesPage', page + 1)
      await this.$store.dispatch({type: 'mattersModule/loadNotes', payload: {matterId: this.matter.uid}})
      if (this.isCompleted) {
        $state.complete();
        return
      }

      $state.loaded();
    },
    handleNoteAction(event) {
      this.$emit('action', event)
    },
    getStaffName(uid) {
      const staff = this.staffMembers.find(staff => staff.uid === uid);
      return staff && staff.full_name;
    }
  }
}
</script>

<style lang="scss" scoped>
.notes-list {
  padding: 24px;
  align-items: stretch;
  width: 100%;
  overflow: auto;
  flex: 1;

  .notes-list-preview {
    width: 100%;
  }
}
</style>
